import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals';
import FileDownloadIcon from "components/FileDownloadIcon";
import CompanyEquipmentMappingLayer from "components/layer/CompanyEquipmentMappingLayer";
import CompanyEquipmentViewerLayer from "components/layer/CompanyEquipmentViewerLayer";
import AddressSearchSwitcher from "components/layer/AddressSearchSwitcher";
import { patchEquipmentZones, postEquipmentZones } from "components/axios/equipmentZoneAxios";
import { ROLE } from "data/data";
import { useEnumApi } from "contexts/EnumApiContext";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";

const CompanyModifyZone = ({company, loginInfo, zones, onRefresh}) => {
    const appLanguage      = (process.env.REACT_APP_LANGUAGE || 'ko').toLowerCase();
    const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();
    const { t, i18n } = useTranslation();
    // const { useNantongSubwayLines } = useEnumApi();
    // const { subwayLines } = useNantongSubwayLines();
    // const nantongCompanyId = process.env.REACT_APP_NANTONG_MANAGEMENT_COMPANY_NO;
    const { useSubwayLines } = useEnumApi();
    const { subwayLines } = useSubwayLines(company.id);

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
                // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const { control:zoneControl, register:zoneRegister, handleSubmit:zoneHandleSubmit
        , reset:zoneReset, setValue:zoneSetValue, formState : {isDirty:zoneIsDirty, errors:zoneErrors } } = useForm({});
    const { control:zoneUpdateControl, register:zoneUpdateRegister, handleSubmit:zoneUpdateHandleSubmit
        , reset:zoneUpdateReset, setValue:zoneUpdateSetValue, formState : {isDirty:zoneUpdateIsDirty, errors:zoneUpdateErrors } } = useForm({});
    
    const [fileLoading, setFileLoading] = useState(false);
    
    const [addressInfo, setAddressInfo] = useState({});
    const [zoneModifyView, setZoneModifyView] = useState([]);

    const [inputZoneImageItems, setInputZoneImageItems] = useState([]);
    const [inputUpdateZoneImageItems, setInputUpdateZoneImageItems] = useState([]);
    const nextImgID = useRef(1);

    useEffect(()=>{
        if (company) {
            let arr2 = Array.from({length : company.equipmentZones.length},() => false);
            setZoneModifyView(arr2);

            if (company.locationMaps) {
                let inputImageItemsCopy = [];
                nextImgID.current = 1;
                for (var j=0;j<company.locationMaps.length;j++) {
                    const input = {	
                        id: nextImgID.current,
                        file: {},
                        zFileMapId: company.locationMaps[j].id,
                        zFile: company.locationMaps[j].file,
                    };
                    inputImageItemsCopy = [...inputImageItemsCopy, input]
                    nextImgID.current += 1;
                }
                setInputZoneImageItems(inputImageItemsCopy);
            }

        }
    },[company])

    function addZoneImageFile(file) {
        const input = {	
            id: nextImgID.current,
            file: {},
            zFileMapId: null,
            zFile: file,
        };

        setInputZoneImageItems([...inputZoneImageItems, input]);
        nextImgID.current += 1;
    }

    // 삭제
    function deleteZoneImage(index) {
        setInputZoneImageItems(inputZoneImageItems.filter(item => item.id !== index));
    }

    function handleZoneImageChange(e, index) {
        if (index > inputZoneImageItems.length) return;
        
        let inputItemsCopy = [...inputZoneImageItems];
        inputItemsCopy[index].file = e.target.files[0];
        inputItemsCopy[index].zFileMapId = null;
        inputItemsCopy[index].zFile = null;
        setInputZoneImageItems(inputItemsCopy);
    }
    
    const nextUpdateImgID = useRef(1);
    function addUpdateZoneImageFile(file) {
        const input = {	
            id: nextUpdateImgID.current,
            file: {},
            zFileMapId : null,
            zFile: file,
        };

        setInputUpdateZoneImageItems([...inputUpdateZoneImageItems, input]);
        nextUpdateImgID.current += 1;
    }

    // 삭제
    function deleteUpdateZoneImage(index) {
        setInputUpdateZoneImageItems(inputUpdateZoneImageItems.filter(item => item.id !== index));
    }

    function handleUpdateZoneImageChange(e, index) {
        if (index > inputUpdateZoneImageItems.length) return;
        
        let inputItemsCopy = [...inputUpdateZoneImageItems];
        inputItemsCopy[index].file = e.target.files[0];
        inputItemsCopy[index].zFileMapId = null;
        inputItemsCopy[index].zFile = null;
        setInputUpdateZoneImageItems(inputItemsCopy);
    }
    
    const zoneOnSubmit = async(data) => {
        setFileLoading(true);
        console.log(data)

        let formData = new FormData();
        let dto = {
            managementCompany : {
                id : company.id
            },
            name : data.zoneName,
            address : data.zoneAddress,
            // latitude : addressInfo.lat,
            // longitude : addressInfo.lng
        }
        // if (appLanguage === 'zh-cn') {
        if (timezone === ('Asia/Shanghai').toLowerCase()) {
            dto.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
        } else {
            dto.latitude = addressInfo?.lat ?? null;
            dto.longitude = addressInfo?.lng ?? null;
        }
        if (data.category) {
            dto.category = {
                code : data.category
            }
        }
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
console.log(dto)
        
        if(inputZoneImageItems) {
            for (var r=0;r<inputZoneImageItems.length;r++) {
                console.log(inputZoneImageItems[r].file)
                if (inputZoneImageItems[r].file && inputZoneImageItems[r].file.name) {
                    console.log(inputZoneImageItems[r].file)
                    formData.append("files", inputZoneImageItems[r].file);
                }
            }
        }

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                console.log('zone write')
                postEquipmentZones(formData).then(()=>{
                    handleAlertClick(t('message.common.alert.write.done'));
                    nextImgID.current = 1;
                    setInputZoneImageItems([]);
                    zoneSetValue('zoneAddress', '');
                    setAddressInfo({});
                    setFileLoading(false);
                    onRefresh();
                    zoneReset();
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                    setFileLoading(false);
                });
            },
            onClose : () => {
                setFileLoading(false);
            },
            message: t('message.common.alert.write.question'),
        });
    }

    const zoneUpdateOnSubmit = async(data) => {
        // console.log(addressInfo)
        // console.log(data)
        setFileLoading(true);

        let formData = new FormData();
        let dto = {
            id : data.zoneIdUpdate,
            // managementCompany : {
            //     id : company.id
            // },
            name : data.zoneNameUpdate,
            address : data.zoneAddressUpdate,
            // latitude : addressInfo.lat,
            // longitude : addressInfo.lng
        }
        // if (appLanguage === 'zh-cn') {
        if (timezone === ('Asia/Shanghai').toLowerCase()) {
            dto.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
        } else {
            dto.latitude = addressInfo?.lat ?? null;
            dto.longitude = addressInfo?.lng ?? null;
        }

        if (data.categoryUpdate) {
            dto.category = {
                code : data.categoryUpdate
            }
        }

        if(inputUpdateZoneImageItems) {
            for (var r=0;r<inputUpdateZoneImageItems.length;r++) {
                // console.log(inputUpdateZoneImageItems[r].file)
                if (inputUpdateZoneImageItems[r].file && inputUpdateZoneImageItems[r].file.name) {
                    // console.log(inputUpdateZoneImageItems[r].file)
                    formData.append("files", inputUpdateZoneImageItems[r].file);
                }
            }
        }

        if (inputUpdateZoneImageItems) {
            let imgFiles = [];
            for (var a1=0;a1<inputUpdateZoneImageItems.length;a1++) {
                if (inputUpdateZoneImageItems[a1].zFile && inputUpdateZoneImageItems[a1].zFile.id)
                    imgFiles.push({id : inputUpdateZoneImageItems[a1].zFileMapId});
            }
            dto.locationMaps = imgFiles;
        }
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
console.log(dto)
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                console.log('zone modify')
                patchEquipmentZones(data.zoneIdUpdate, formData).then(()=>{
                    handleAlertClick(t('message.common.alert.modify.done'));
                    nextUpdateImgID.current = 1;
                    setInputUpdateZoneImageItems([]);
                    zoneSetValue('zoneAddress', '');
                    zoneUpdateSetValue('zoneUpdateAddress', '');
                    setAddressInfo({});
                    setFileLoading(false);
                    onRefresh();
                    zoneUpdateReset();
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                    setFileLoading(false);
                    zoneSetValue('zoneAddress', '');
                });
            },
            onClose : () => {
                setFileLoading(false);
            },
            message: t('message.common.alert.modify.question'),
        });
    }

    // const handleZoneDeleteBtnClick = (param) => {
    //     console.log(param)

    //     openModal(modals.confirmModal, {
    //         onSubmit : (value) => {
    //             console.log('zone delete')
    //         },
    //         onClose : () => {
    //         },
    //         message: t('message.common.alert.delete.question'),
    //     });
    // }

    function updateButtonClick(zone, j) {
        // console.log(zone)
        let zoneinfo = {
              address_name: zone.address
        }
        // if (appLanguage === 'zh-cn') {
        if (timezone === ('Asia/Shanghai').toLowerCase()) {
            zoneinfo.chinaRegionCode = zone?.chinaRegion?.selected?.code ?? null;
        } else {
            zoneinfo.lat = zone?.latitude ?? null;
            zoneinfo.lng = zone?.longitude ?? null;
        }
        setAddressInfo(zoneinfo)
        zoneUpdateReset({'zoneAddressUpdate': zone.address});
        if (zone.locationMaps) {
            let inputImageItemsCopy = [];
            nextUpdateImgID.current = 1;
            for (var k = 0; k < zone.locationMaps.length; k++) {
                const input = {
                    id: nextUpdateImgID.current,
                    file: {},
                    zFileMapId: zone.locationMaps[k].id,
                    zFile: zone.locationMaps[k].file,
                };
                inputImageItemsCopy = [...inputImageItemsCopy, input];
                nextUpdateImgID.current += 1;
            }
            setInputUpdateZoneImageItems(inputImageItemsCopy);
        }

        let arr = Array.from({ length: zones.length }, () => false);
        arr[j] = true;
        setZoneModifyView(arr);
        zoneUpdateReset();
    }

    // if (company.type === 'MAN') {
        return (
        <React.Fragment>
        {/* 구역 목록 */}
        <br/>
        <div>
            <div className="mro_search">
              <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.title.zone.list')}</h6>
            </div>
            {/* 관리자라면 구역관리를 할 수 있음. */}
            {(loginInfo.role === ROLE.SA.code || loginInfo.role === ROLE.AD.code) &&
            <TableContainer>
                <form onSubmit={zoneHandleSubmit(zoneOnSubmit)}>
                <Table aria-label="simple table">
                  <TableBody>
                    { zones?.length > 0 && zones.map(function(zone, j) {
                        // console.log(zone)
                      if (zoneModifyView[j]) {  // 수정폼
                      return (
                    <React.Fragment key={j}>
                    <TableRow style={{borderTop:"3px solid"}}>
                      <TableCell className="th" align="center" style={{width:'300px'}}>{t('message.common.subtitle.zone.name')}</TableCell>
                      <TableCell style={{textAlign:'left'}}>
                        <input type="hidden" {...zoneUpdateRegister("zoneIdUpdate")} value={zone.id || ''} />
                        <TextField id="zoneNameUpdate" 
                            aria-invalid={!zoneUpdateIsDirty ? undefined : zoneUpdateErrors.zoneNameUpdate ? "true" : "false"}
                            defaultValue={zone.name || ''}
                            key={'zoneNameUpdate'}
                            {...zoneUpdateRegister("zoneNameUpdate", {
                                required : t('message.common.error.text.zone.name.input')
                            })} 
                            sx={{ m: 1, minWidth: '90%' }} 
                        />
                        {zoneUpdateErrors.zoneNameUpdate && <small role="alert"><br></br>{zoneUpdateErrors.zoneNameUpdate.message}</small>}
                      </TableCell>
                      <TableCell rowSpan={3} style={{width:'150px'}}>
                        <Button variant="outlined" color="success" className="small_btn" type="button"
                            onClick={zoneUpdateHandleSubmit(zoneUpdateOnSubmit)}
                        >{t('message.common.btn.modify')}</Button>&nbsp;
                        <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                            let arr = Array.from({length : zones.length},() => false);
                            arr[j] = false;
                            setZoneModifyView(arr);
                            zoneUpdateReset();
                        }}>{t('message.common.btn.cancel')}</Button>
                      </TableCell>
                    </TableRow>
                    {subwayLines?.length>0 &&
                        <TableRow style={{backgroundColor: "#1e2a38"}}>
                            <TableCell className="th" align="center" style={{lineHeight:'50px', width:'300px'}}>{t('message.common.subtitle.subwayline')}</TableCell>
                            <TableCell style={{textAlign:'left'}}>
                            <Controller
                                name="categoryUpdate"
                                control={zoneUpdateControl}
                                render={({ field:{ name }}) => (
                                    <CustomFormEnumSelect
                                        style={{ minWidth: '90%', margin:"8px" }}
                                        label={t('message.common.subtitle.subwayline')}
                                        register={zoneUpdateRegister}
                                        name={name}
                                        // requiredMessage={t('message.common.error.text.subwayline.select')}
                                        defaultValue={zone.category?.code || ''}
                                        key={'categoryUpdate'}
                                        list={subwayLines}
                                    />
                                )}
                                rules={{ required: true }}
                            />
                            {zoneUpdateErrors.categoryUpdate && <small role="alert"><br></br>{zoneUpdateErrors.categoryUpdate.message}</small>}
                            </TableCell>
                        </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.address')}</TableCell>
                      <TableCell style={{textAlign:'left'}}>
                        <Controller
                            control={zoneUpdateControl}
                            name="zoneAddressUpdate"
                            rules={{ required: t('message.common.error.text.address.input') }}
                            render={({ field, fieldState }) => (
                            <AddressSearchSwitcher register={zoneUpdateRegister} setValue={zoneUpdateSetValue} field={field} fieldState={fieldState} 
                                errors={zoneUpdateErrors} setAddressInfo={setAddressInfo} objName={'zoneAddressUpdate'} addressInfo={addressInfo} />
                            )}
                        />
                        {/* {zoneUpdateErrors.zoneAddressUpdate && <small role="alert"><br></br>{zoneUpdateErrors.zoneAddressUpdate.message}</small>} */}
                        {/* <AddressSearchSwitcher control={zoneUpdateControl} register={zoneUpdateRegister} setValue={zoneUpdateSetValue} isDirty={zoneUpdateIsDirty} 
                        errors={zoneUpdateErrors} setAddressInfo={setAddressInfo} objName={'zoneAddressUpdate'} defaultVal={addressInfo.address_name || ''} /> */}
                        {/* {zoneUpdateErrors.zoneAddressUpdate && <small role="alert"><br></br>{zoneUpdateErrors.zoneAddressUpdate.message}</small>} */}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center" style={{lineHeight:'50px'}}>
                        {t('message.common.subtitle.zone.image')}
                        {inputUpdateZoneImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addUpdateZoneImageFile}>+</AddCircleOutlineIcon>}
                      </TableCell>
                      <TableCell style={{textAlign:'left'}}>
                         {inputUpdateZoneImageItems && inputUpdateZoneImageItems.map(function(item, index) {
                            return (
                            <div key={index} style={{display:"flex", paddingLeft:"8px"}}>
                                {((!item.file?.name)) && <input
                                    type="file"
                                    accept="image/*"
                                    value={''}
                                    onChange={e => {
                                        handleUpdateZoneImageChange(e, index);
                                    }}
                                />
                                }
                                {(item.file && item.file.name) ? item.file.name : (item.zFile && item.zFile.id && <><FileDownloadIcon file={item.zFile} viewFileName={true} fontColor="#000" /></>)}
                                { inputUpdateZoneImageItems[index] ? (
                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteUpdateZoneImage(item.id)}>-</RemoveCircleOutlineIcon>
                                ) : (
                                ''
                                )}
                            </div>
                            )
                        })}
                      </TableCell>
                    </TableRow>
                    </React.Fragment>
                      )
                      } else {   // 목록
                        return (
                    <React.Fragment key={j}>
                    <TableRow style={{borderTop:"3px solid"}}>
                      <TableCell className="th" align="center" style={{lineHeight:'50px', width:'300px'}}>{t('message.common.subtitle.zone.name')}</TableCell>
                      <TableCell>{zone.name || ''}</TableCell>
                      <TableCell rowSpan={3} style={{width:'150px'}}>
                        <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                            updateButtonClick(zone, j);
                        }}>{t('message.common.btn.modify')}</Button>&nbsp;
                        {/* <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                            handleZoneDeleteBtnClick(zone.id);  
                        }}>{t('message.common.btn.delete')}</Button> */}
                      </TableCell>
                    </TableRow>
                    {subwayLines?.length>0 &&
                    <TableRow>
                        <TableCell className="th" align="center" style={{lineHeight:'50px', width:'300px'}}>{t('message.common.subtitle.subwayline')}</TableCell>
                        <TableCell>{zone.category?.name?.[i18n.language.substring(0, 2)] || ''}</TableCell>
                    </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th" align="center" style={{lineHeight:'50px'}}>{t('message.common.subtitle.address')}</TableCell>
                      <TableCell>{zone.address || ''}</TableCell>
                    </TableRow>
                    <TableRow style={{borderBottom:"2px solid"}}>
                      <TableCell className="th" align="center">
                        {t('message.common.subtitle.zone.image')}<br/>
                        {t('message.common.guide.zone.coordinate.equipment.mapping')}
                      </TableCell>
                      <TableCell>
                        {zone.locationMaps?.map((map, mIdx)=>{
                            // console.log(map)
                            if (map.file) {
                                const extension = map.file?.originFile.substring(map.file?.originFile.lastIndexOf(".")+1);
                                // console.log(map.file?.originFile)
                                // console.log(extension)
                                if (extension.toLowerCase() !== 'svg') {
                            return (
                                <CompanyEquipmentMappingLayer key={mIdx} fileId={map.file?.id} mapsId={map.id} zoneId={zone.id} />
                            )
                                } else {
                            return (
                                <img key={mIdx}
                                    src={`${window.RUNTIME_CONFIG.REACT_APP_API_URL}/api/download/${map.file?.id}`}
                                    alt="Thumbnail"
                                    style={{width: "80px" ,height: "80px" ,padding:"3px"}}
                                />
                            )
                                }
                            }
                        })}
                      </TableCell>
                    </TableRow>
                    </React.Fragment>
                        )
                      }
                    })}
                  {/* </TableBody> */}
                  {/* 등록 */}
                    <TableRow style={{borderTop:"5px double"}}>
                      <TableCell className="th" align="center" style={{lineHeight:'50px', borderBottom:'1px solid #515151'}}>{t('message.common.subtitle.zone.name')}</TableCell>
                      <TableCell style={{borderBottom:'1px solid #515151', textAlign:'left'}}>
                        <TextField id="zoneName" 
                            aria-invalid={!zoneIsDirty ? undefined : zoneErrors.zoneName ? "true" : "false"}
                            defaultValue={''}
                            key={'zoneName'}
                            {...zoneRegister("zoneName", {
                                required : t('message.common.error.text.zone.name.input')
                            })} 
                            sx={{ m: 1, minWidth: '90%' }} 
                        />
                        {zoneErrors.zoneName && <small role="alert"><br></br>{zoneErrors.zoneName.message}</small>}
                      </TableCell>
                      <TableCell rowSpan={3} style={{width:'150px'}}>
                        <Button type="submit" variant="contained" color="primary" 
                            onClick={zoneHandleSubmit(zoneOnSubmit)}
                        >{t('message.common.btn.add')}</Button>
                      </TableCell>
                    </TableRow>
                    {subwayLines?.length>0 &&
                        <TableRow>
                            <TableCell className="th" align="center" style={{lineHeight:'50px', width:'300px'}}>{t('message.common.subtitle.subwayline')}</TableCell>
                            <TableCell style={{textAlign:'left'}}>
                            <Controller
                                name="category"
                                control={zoneControl}
                                render={({ field:{ name }}) => (
                                    <CustomFormEnumSelect
                                        style={{ minWidth: '90%', margin:"8px" }}
                                        label={t('message.common.subtitle.subwayline')}
                                        register={zoneRegister}
                                        name={name}
                                        // requiredMessage={t('message.common.error.text.subwayline.select')}
                                        defaultValue={''}
                                        key={'category'}
                                        list={subwayLines}
                                    />
                                )}
                                rules={{ required: true }}
                            />
                            {zoneErrors.category && <small role="alert"><br></br>{zoneErrors.category.message}</small>}
                            </TableCell>
                        </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th" align="center" style={{lineHeight:'50px', borderBottom:'1px solid #515151'}}>{t('message.common.subtitle.address')}</TableCell>
                      <TableCell style={{borderBottom:'1px solid #515151', textAlign:'left'}}>
                        <Controller
                            control={zoneControl}
                            name="zoneAddress"
                            rules={{ required: t('message.common.error.text.address.input') }}
                            render={({ field, fieldState }) => (
                            <AddressSearchSwitcher register={zoneRegister} setValue={zoneSetValue} field={field} fieldState={fieldState} 
                                errors={zoneErrors} setAddressInfo={setAddressInfo} objName={'zoneAddress'} /*addressInfo={{address_name:addressInfo?.address_name || '', lat:addressInfo?.lat, lng:addressInfo?.lng}} */ />
                            )}
                        />
                        {/* {zoneErrors.zoneAddress && <small role="alert"><br></br>{zoneErrors.zoneAddress.message}</small>} */}
                        {/* <AddressSearchSwitcher control={zoneControl} register={zoneRegister} setValue={zoneSetValue} isDirty={zoneIsDirty} errors={zoneErrors} setAddressInfo={setAddressInfo} objName={'zoneAddress'} defaultVal={addressInfo?.address_name || ''} />
                        {zoneErrors.zoneAddress && <small role="alert"><br></br>{zoneErrors.zoneAddress.message}</small>} */}
                      </TableCell>
                    </TableRow>
                    <TableRow style={{borderBottom:"3px solid"}}>
                      <TableCell className="th" align="center" style={{lineHeight:'50px'}}>
                        {t('message.common.subtitle.zone.image')}
                        {inputZoneImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addZoneImageFile}>+</AddCircleOutlineIcon>}
                      </TableCell>
                      <TableCell style={{textAlign:'left'}}>
                         {inputZoneImageItems && inputZoneImageItems.map(function(item, index) {
                            return (
                            <div key={index} style={{display:"flex", paddingLeft:"8px"}}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    value={''}
                                    onChange={e => {
                                        handleZoneImageChange(e, index);
                                    }}
                                />
                                {(item.file && item.file.name) ? item.file.name : (item.zFile && item.zFile.id && <><FileDownloadIcon file={item.zFile} viewFileName={true} fontColor="#000" /></>)}
                                { inputZoneImageItems[index] ? (
                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteZoneImage(item.id)}>-</RemoveCircleOutlineIcon>
                                ) : (
                                ''
                                )}
                            </div>
                            )
                        })}
                      </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
                </form>
            </TableContainer>
            }
            {/* 관리자가 아니면 구역 목록만 보여줌 */}
            {(loginInfo.role !== ROLE.SA.code && loginInfo.role !== ROLE.AD.code) &&
            <TableContainer>
                <Table aria-label="simple table">
                  <TableBody>
                    { zones?.length > 0 && zones.map(function(zone, j) {
                        console.log(zone.id)
                      return (
                    <React.Fragment key={j}>
                    <TableRow style={{borderTop:"2px solid"}}>
                      <TableCell className="th" align="center">{t('message.common.subtitle.zone.name')}</TableCell>
                      <TableCell>{zone.name || ''}</TableCell>
                    </TableRow>
                    {subwayLines?.length>0 &&
                    <TableRow>
                        <TableCell className="th" align="center" style={{lineHeight:'50px', width:'300px'}}>{t('message.common.subtitle.subwayline')}</TableCell>
                        <TableCell>{zone.category?.name?.[i18n.language.substring(0, 2)] || ''}</TableCell>
                    </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.address')}</TableCell>
                      <TableCell>{zone.address || ''}</TableCell>
                    </TableRow>
                    <TableRow style={{borderBottom:"2px solid"}}>
                      <TableCell className="th" align="center">{t('message.common.subtitle.zone.image')}</TableCell>
                      <TableCell>
                        {zone.locationMaps?.map((map, mIdx)=>{
                            if (map.file) {
                                const extension = map.file?.originFile.substring(map.file?.originFile.lastIndexOf(".")+1);
                                if (extension.toLowerCase() !== 'svg') {
                            return (
                                <CompanyEquipmentViewerLayer key={mIdx} fileId={map.file?.id} mapsId={map.id} />
                            )
                                } else {
                            return (
                                <img key={mIdx}
                                    src={`${window.RUNTIME_CONFIG.REACT_APP_API_URL}/api/download/${map.file?.id}`}
                                    alt="Thumbnail"
                                    style={{width: "80px" ,height: "80px" ,padding:"3px"}}
                                />
                            )
                                }
                            }
                        })}
                      </TableCell>
                    </TableRow>
                    </React.Fragment>
                      )
                    })}
                  </TableBody>
                </Table>
            </TableContainer>
            }
        </div>
        </React.Fragment>
        )
    // }
}

export default CompanyModifyZone;